<template>
  <div class="info-title">
    <p>{{ content }}</p>
  </div>
</template>

<script>
export default {
  name: 'MainTitle',
  props: {
    content: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.info-title {
  margin-top: -40px;
  margin-bottom: 10px;
  text-align: left;
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
  padding: 10px;
}
</style>
